/*
 *
 *  UI Snackbar Store
 */

// state
const state = {
  snackbar: {
    color: '',
    text: '',
    show: false,
    multi: false,
    timeout: 6000,
    action: false,
    actionText: null
  }
}

// getters
const getters = {
  getSnackbar: state => {
    return state.snackbar
  }
}

// actions
const actions = {
  showSnackbar({ commit }, data) {
    commit('setSnackbar', data)
  }
}

// mutations
const mutations = {
  setSnackbar(state, data) {
    // default color
    var color = 'primary'
    // check status
    if (data.status === 'success') {
      color = 'success'
    } else if (data.status == 'error') {
      color = 'error'
    }
    // set snackbar
    const snackbar = {
      color: color,
      text: data.text ? data.text : null,
      multi: data.multi ? data.multi : false,
      timeout: data.timeout || data.timeout === 0 ? data.timeout : 6000,
      action: data.action ? data.action : false,
      actionText: data.actionText ? data.actionText : null,
      show: true
    }
    // update snackbar
    state.snackbar = snackbar
  }
}

// export
export default {
  state,
  getters,
  actions,
  mutations
}
